
  //    this file used to style the chat popup button 
  (() => {
    const roots = new WeakSet();

    const animationCSS = `
      @keyframes bounceAttention {
        0%,80%,100% { transform: translateY(0); }
        85% { transform: translateY(-10px); }
        90% { transform: translateY(0); }
        95% { transform: translateY(-5px); }
      }
    `;

    const addAnimation = (root) => {
      if (!root.querySelector("#chat-animation-style")) {
        const style = document.createElement("style");
        style.id = "chat-animation-style";
        style.textContent = animationCSS;
        root.appendChild(style);
      }
    };

    const applyStyles = (root) => {
      addAnimation(root);

      const label = root.querySelector(".activator__label");
      const icon = root.querySelector(".activator__icon");
      const button = root.querySelector(".activator");
      const chatIcon = root.querySelector("shopify-chat-icon");

      if (label) {
        label.style.setProperty("font-size", "20px", "important");
        label.style.setProperty("font-weight", "700", "important");
      }

      if (icon) {
        icon.style.setProperty("width", "28px", "important");
        icon.style.setProperty("height", "28px", "important");

        const svg = icon.querySelector("svg");
        if (svg) {
          svg.style.setProperty("width", "28px", "important");
          svg.style.setProperty("height", "28px", "important");
        }
      }

      if (chatIcon) {
        chatIcon.style.setProperty("width", "28px", "important");
        chatIcon.style.setProperty("height", "28px", "important");
      }

      if (button) {
        button.style.setProperty(
          "background-color",
          "color-mix(in srgb, var(--activator-bg) 100%, transparent)",
          "important"
        );

        button.style.setProperty(
          "animation",
          "bounceAttention 3s infinite",
          "important"
        );
      }
    };

    const watchRoot = (root) => {
      if (!root || roots.has(root)) return;

      roots.add(root);

      applyStyles(root);

      new MutationObserver(() => {
        applyStyles(root);

        root.querySelectorAll("*").forEach((el) => {
          if (el.shadowRoot) {
            watchRoot(el.shadowRoot);
          }
        });
      }).observe(root, {
        childList: true,
        subtree: true
      });

      root.querySelectorAll("*").forEach((el) => {
        if (el.shadowRoot) {
          watchRoot(el.shadowRoot);
        }
      });
    };

    const scan = () => {
      document.querySelectorAll("*").forEach((el) => {
        if (el.shadowRoot) {
          watchRoot(el.shadowRoot);
        }
      });
    };

    new MutationObserver(scan).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    scan();
  })();